import { Construction } from 'lucide-react';

export function ComingSoonPage({ feature }: { feature: string }) {
  return (
    <div className="grid place-items-center py-20">
      <div className="card max-w-md p-10 text-center">
        <div className="mx-auto mb-5 grid h-14 w-14 place-items-center rounded-2xl bg-gradient-to-br from-accent-50 to-brand-50">
          <Construction className="h-7 w-7 text-accent-700" />
        </div>
        <h1 className="mb-2 text-xl font-semibold text-ink-primary">{feature}</h1>
        <p className="text-sm leading-relaxed text-ink-muted">
          Route is scaffolded. The full module ships with the corresponding epic — in the meantime
          your role-based access and audit logging are already wired through.
        </p>
        <div className="mt-5 inline-flex items-center gap-1.5 rounded-full bg-accent-50 px-3 py-1 text-[11px] font-semibold uppercase tracking-wider text-accent-700">
          Coming soon
        </div>
      </div>
    </div>
  );
}
